import React from 'react'
import PersistedComponent from '../PersistedComponent'
import { VerticalRow } from '../../utils/Grid'
import WidgetContainer from '../../containers/WidgetContainer'
import CarsBox from './StyledCarsBox'
import utmLinkGenerator from '../../utils/UTMLinkGenerator'
import { type CarsWidgetProps } from '../Types'

export default class Cars extends PersistedComponent {
  constructor (props: CarsWidgetProps) {
    super(props)

    this.persistedKeys.push('isOpen')

    this.state = Object.assign({ isOpen: true }, this.state)
  }

  handleToggleContent () {
    const {
      isOpen
    } = this.state

    this.setState({
      isOpen: !isOpen
    })
  }

  render () {
    const {
      props: {
        activeDynamicLayout,
        isOpening,
        widget,
        widget: {
          boxes,
          imageSize,
          utmMedium
        }
      },
      state: {
        isOpen
      }
    } = this

    if (!boxes.length) {
      return null
    }

    return (
      <WidgetContainer
        activeDynamicLayout={activeDynamicLayout}
        handleToggleContent={this.handleToggleContent.bind(this)}
        isOpen={isOpen}
        isOpening={isOpening}
        widget={widget}
      >
        <VerticalRow>
          {
            boxes.map((box, index) => {
              const {
                annotation,
                images,
                link,
                price,
                source,
                title
              } = box

              const image = images[imageSize]

              const utmLink = utmLinkGenerator.createLink(link, {
                utmMedium,
                utmTerm: `position-${index}`,
                utmCampaign: source
              })

              return (
                <CarsBox
                  annotation={annotation}
                  image={image}
                  imageClass={`image-${imageSize}`}
                  key={`car-${index}`}
                  link={utmLink}
                  price={price}
                  title={title}
                />
              )
            })
          }
        </VerticalRow>
      </WidgetContainer>
    )
  }
}
